"use client";

import { useEffect } from 'react';
import { useAuthToken } from '@/context/AuthTokenContext';
import { useTranslation } from '@/hooks/useTranslation';

/**
 * Translation Provider component that initializes the translation system
 * Should be used high in the component tree, preferably in the root layout
 */
export const TranslationProvider = ({ children }) => {
  const { isAuthReady } = useAuthToken();
  const { initializeTranslations, translationError } = useTranslation();

  useEffect(() => {
    // Only initialize translations after auth client is ready
    if (isAuthReady) {
      initializeTranslations().catch(error => {
        console.error('Failed to initialize translations:', error);
      });
    }
  }, [initializeTranslations, isAuthReady]);

  // You can add error boundary logic here if needed
  if (translationError) {
    console.warn('Translation error:', translationError);
    // Could show a toast notification or error message
  }

  return children;
};

export default TranslationProvider;
